export default __webpack_public_path__ + "650b9df9f0fdf7c45c8ad303a9eb7455.png";